export enum SubscriptionTabsModel {
  MySubscriptions = 0,
  ManageSubscribers = 1,
}